import { ApiPutRequest } from './api-put-request';
import { Order } from '../../interfaces/order';
import { BankAccount } from '../../interfaces/bank-account';
import { ApiParameters } from './api-parameters';
import { Visitor } from 'src/app/model/visitor';

export class PaymentBsRequest extends ApiPutRequest
{
    public constructor(player: Visitor, order: Order, bankAccount: BankAccount, webapiBasepath: string)
    {
        super(  'paymentbs', 
                new ApiParameters(), 
                null, 
                {
                    player, orderid: order.Id, bankAccount
                },
                webapiBasepath
            );
    }
}
